import React from 'react';
import { Helmet } from 'react-helmet';
import App from '../components/App';
import { headData } from '../mock/data';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';
import '../style/chat.css';

export default () => {
  const { title, lang, description } = headData;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Yamin Huzaifa"}</title>
        <html lang={lang || 'en'} />
        <meta name="description" content={'Full-Stack developer'} />
      </Helmet>
      <App />
    </>
  );
};
